import React, {PureComponent} from 'react'

export default class FakeLogin extends PureComponent {
    render() {
        return <div>
            <h1>Your tab has been redirected to this fake login page.</h1>
            <p>Using your imagination, pretend this page was made to look exactly like the "Your session has expired.
                Please log in again" page of the website this tab was just on.</p>
        </div>
    }
}
